import { I18n } from 'next-i18next'

import { i18n, initReactI18next, ja, ko, en, th, china, tw } from '../../lang'
import { Locales } from '../language'

type Props = { locale: Locales | string }
const createI18n = ({ locale }: Props): I18n => {
  i18n.use(initReactI18next).init({
    lng: locale,
    resources: {
      ko,
      ja,
      en,
      th,
      'zh-Hans': china, // legacy key kept for compatibility
      'zh-Hant': tw, // legacy key kept for compatibility
      'zh-Hans-CN': china, // canonical key
      'zh-Hant-TW': tw, // canonical key
    },
    fallbackLng: 'ko',
    keySeparator: '.',
    interpolation: { escapeValue: false },
  })
  return i18n
}

export default createI18n
